var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',{attrs:{"fluid":""}},[_c('v-layout',{attrs:{"row":"","wrap":""}},[_c('v-btn',{attrs:{"flat":""},nativeOn:{"click":function($event){return _vm.goBack.apply(null, arguments)}}},[_c('v-icon',{attrs:{"left":""}},[_vm._v("keyboard_backspace")]),_vm._v("Вернуться")],1)],1),_c('ClinicItem',{attrs:{"clinic":_vm.clinicInfo}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }